<div class="card-custom-fit">
  <div class="card card-custom gutter-b">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">API Fetching - <span class="text-dark-50">{{entityName}}</span></h3>
      </div>
      <div class="card-toolbar">
        <a type="button" class="btn btn-light" (click)="onNavigateToDataView()">
          <i class="fa fa-arrow-left"></i>Back
        </a>
      </div>
    </div>
    <div class="card-body">
      <mat-tab-group>
        <mat-tab label="Get by key">
          <div *ngIf="rsSchemaPkList.length === 0" class="api-fetch-reload">
            <div class="d-flex center h-100 w-100"
                 style="position: fixed; align-items: center; top: 50%; flex-direction: column;">
              <h3 class="text-center">No primary key column exist in this entity! <br>
                You should have at least one primary key in this entity so as to use this fetching api!
              </h3>
            </div>
          </div>

          <div class="form-group row p-3">
            <div class="col-lg-4">
              <label>Http Method</label>
              <input
                title
                type="text"
                class="form-control form-control-lg form-control-solid"
                placeholder="Http Method"
                value="GET"
                disabled
              />
            </div>
            <div class="col-lg-8">
              <label>Request URL</label>
              <div class="input-group">
                <input
                  title
                  id="GetByKeyUrl"
                  type="text"
                  class="form-control form-control-lg form-control-solid"
                  placeholder="Get by key url"
                  value="{{getByKeyUrl}}"
                  disabled
                />
                <div class="input-group-append">
                  <a href="#" class="btn btn-secondary"
                     (click)="copyUrl(getByKeyUrl)"><i class="fa fa-copy"></i></a>
                </div>
              </div>
            </div>
          </div>

          <!-- Headers  -->
          <div class="p-3">
            <label>Headers</label>
            <table
              class="table table-head-custom table-vertical-center overflow-hidden"
            >
              <thead>
              <th>Key</th>
              <th>Value</th>
              </thead>
              <tbody>
              <tr>
                <td>token</td>
                <td>
                  <div class="form-group row">
                    <div class="col-lg-10">
                      {{localToken}}
                    </div>
                    <div class="col-lg-2">
                      <a href="#" class="btn btn-secondary"
                         (click)="copyValue(localToken)"><i class="fa fa-copy"></i></a>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <!-- Params  -->
          <div class="p-3">
            <label>Params</label>
            <table
              class="table table-head-custom table-vertical-center overflow-hidden"
            >
              <thead>
              <th>Key</th>
              <th>Value</th>
              <th>Description</th>
              </thead>
              <tbody>
                <tr>
                  <td>daeID</td>
                  <td>{{daeID}}</td>
                  <td>data entity ID</td>
                </tr>
                <tr *ngIf="rsSchemaPkList.length === 0">
                  <td class="text-align-center border" colspan="100">
                    No primary key column exist in this entity
                  </td>
                </tr>
                <tr *ngFor="let pk of rsSchemaPkList">
                  <td>{{pk.fieldName}}</td>
                  <td><b>Target Value</b></td>
                  <td>Target value correspond to the '<b>{{pk.fieldName}}</b>' ({{pk.dataType | textCase}})</td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-tab>
        <mat-tab label="Get by batch">
          <div class="form-group row p-3">
            <div class="col-lg-4">
              <label>Http Method</label>
              <input
                title
                type="text"
                class="form-control form-control-lg form-control-solid"
                placeholder="Http Method"
                value="GET"
                disabled
              />
            </div>
            <div class="col-lg-8">
              <label>Request URL</label>
              <div class="input-group">
                <input
                  title
                  id="getByBatchUrl"
                  type="text"
                  class="form-control form-control-lg form-control-solid"
                  placeholder="Get by batch url"
                  value="{{getByBatchUrl}}"
                  disabled
                />
                <div class="input-group-append">
                  <a href="#" class="btn btn-secondary"
                     (click)="copyUrl(getByBatchUrl)"><i class="fa fa-copy"></i></a>
                </div>
              </div>
            </div>
          </div>

          <!-- Headers  -->
          <div class="p-3">
            <label>Headers</label>
            <table
              class="table table-head-custom table-vertical-center overflow-hidden"
            >
              <thead>
              <th>Key</th>
              <th>Value</th>
              </thead>
              <tbody>
              <tr>
                <td>token</td>
                <td>
                  <div class="form-group row">
                    <div class="col-lg-10">
                      {{localToken}}
                    </div>
                    <div class="col-lg-2">
                      <a href="#" class="btn btn-secondary"
                         (click)="copyValue(localToken)"><i class="fa fa-copy"></i></a>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- Params  -->
          <div class="p-3">
            <label>Params</label>
            <table
              class="table table-head-custom table-vertical-center overflow-hidden"
            >
              <thead>
              <th>Key</th>
              <th>Value</th>
              <th>Description</th>
              </thead>
              <tbody>
              <tr>
                <td>daeID</td>
                <td>{{daeID}}</td>
                <td>data entity ID</td>
              </tr>
              <tr>
                <td>start</td>
                <td>integer: eg. 0, 10</td>
                <td>The first record is start at 0</td>
              </tr>
              <tr>
                <td>length</td>
                <td>integer: eg. 0, 10, 20</td>
                <td>Length of the records (maximum is 5000)</td>
              </tr>
              </tbody>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
